import { render, staticRenderFns } from "./FileUpload2.vue?vue&type=template&id=2520eaa2&scoped=true&"
import script from "./FileUpload2.vue?vue&type=script&lang=js&"
export * from "./FileUpload2.vue?vue&type=script&lang=js&"
import style0 from "./FileUpload2.vue?vue&type=style&index=0&id=2520eaa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2520eaa2",
  null
  
)

export default component.exports